module.exports = __webpack_public_path__ + "img/H4.e2430078.png";